import { injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { Platform } from "src/libs/platform";
import { Environment } from "src/libs/environment";

@injectable()
export class BiometricService {
    private static readonly isEnabled =
        Environment.string("BIOMETRIC_FEATURE") === "on";
    private static readonly disabledOn = Environment.string(
        "BIOMETRIC_FEATURE_DISABLED_ON",
        "none"
    );

    @autoBind
    isAllowed(): boolean {
        const isDisabledOnIOS =
            Platform.isIOS() &&
            BiometricService.disabledOn.toLowerCase() === Platform.SO_IOS;
        const isDisabledOnAndroid =
            Platform.isAndroid() &&
            BiometricService.disabledOn.toLowerCase() === Platform.SO_ANDROID;

        const isDisabledByPlatform = isDisabledOnIOS || isDisabledOnAndroid;

        return (
            Platform.isRunningOnFlutter() &&
            BiometricService.isEnabled &&
            !isDisabledByPlatform
        );
    }
}
